import React,{useState} from 'react';
import {TextField,Grid,IconButton, InputAdornment, Button ,Select, MenuItem, FormControl} from '@mui/material';
import '../../../Styles/profileDetails.scss'; 
import { Visibility, VisibilityOff } from '@mui/icons-material';

const AddInputField = ({
  label = '',
  sizemd = 0,
  sizelg = 4,
  isRequired = false,
  label2 = '',
  name,
  onInputChange,
  doubleField = false,
  multiline = false,
  rows,
  urlLabel = '',
  name2 = '',
  sizesm = 4,
  isNumberField = false,
  errors,
  register,
  disabled = false,
  pattern={},
  required=""
}) => {
  return (
    <Grid key={name} item xs={10} sm={sizesm} md={sizemd} lg={sizelg}>
      <div className="addVideo_form_field_div">
        <div className="form_label">
          {urlLabel ? urlLabel.key : label}
          {isRequired && <span className={"required"}>*</span>}
        </div>
        <TextField
          size="small"
          fullWidth
          name={name}
          className={"textfield"}
          multiline={multiline}
          rows={multiline ? rows : undefined}
          type={isNumberField ? 'number' : 'text'}
          {...register(name, {
            required,
           pattern
          })}
          error={!!errors[name]}
          // helperText={errors[name]?.message}
          style={errors[name] ? { border: 0 } : undefined}
          onBlur={onInputChange}
          disabled={disabled}
        />
        {errors[name] && (
          <div className="error-message">{errors[name].message}</div>
        )}
      </div>
      {doubleField && (
        <div
          className="addVideo_form_field_div"
          style={
            errors[name2]
              ? {
                  border: 0,
                  position: 'relative',
                  top: '-20px',
                  margin: '0px',
                }
              : undefined
          }
        >
          <div className="form_label2">
            {label2}
            {isRequired && <span className="required">*</span>}
          </div>
          <TextField
            name={name2}
            size="small"
            fullWidth
            className="textfield2"
            type={isNumberField && name2 !== 'duration' ? 'number' : 'text'}
            {...register(name2, {
              required: `${label2} is required`,
            })}
            error={!!errors[name2]}
            helperText={errors[name2]?.message}
            onBlur={onInputChange}
          />
        </div>
      )}
    </Grid>
  );
};
const AddProfileTitle = ({ label = '', icon1 = '', icon2 = '' }) => {
  const selectedIcon = icon1 || icon2;

  return (
    <Grid item xs={12} style={{ marginTop: '20px' }}>
      <div className="videoTitle-component">
        <div className="icon">
          {selectedIcon && <img src={selectedIcon} alt={`${label} icon`} />}
        </div>
        <div className="videoTitle">{label}</div>
      </div>
    </Grid>
  );
};

const PasswordInputField = ({
  label = 'Password',
  sizemd = 0,
  sizelg = 4,
  sizesm = 4,
  isRequired = false,
  name = 'password',
  errors,
  register,
  onInputChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Grid key={name} item xs={10} sm={sizesm} md={sizemd} lg={sizelg}>
      <div className="addVideo_form_field_div">
        <div className="form_label">
          {label}
          {isRequired && <span className="required">*</span>}
        </div>
        <TextField
          size="small"
          fullWidth
          name={name}
          type={showPassword ? 'text' : 'password'}
          className="textfield"
          {...register(name, {
            required: `${label} is required`,
          })}
          error={!!errors[name]}
          // helperText={errors[name]?.message}
          onBlur={onInputChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={togglePasswordVisibility}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
         {errors[name] && (
          <div className="error-message">{errors[name]?.message}</div>
        )}
      </div>
    </Grid>
  );
};
const UpdateButton = ({
  label = '', onClick
}) => {
  return (
    <Grid item xs={12} className='updateButton'>
      <Button
        variant="contained"
        onClick={onClick}
        sx={{
          backgroundColor: '#E1540F',
          '&:hover': {
            backgroundColor: '#E1540F',
          },
        }}
      >
        {label}
      </Button>
    </Grid>
  );
};


const DropdownField = ({
  label = '',
  sizemd = 0,
  sizelg = 4,
  sizesm = 4,
  isRequired = false,
  name,
  onInputChange,
  isDropdown = false,
  dropdownOptions = [],
  errors,
  register,
  defaultValue,
}) => {
  return (
    <Grid key={name} item xs={10} sm={sizesm} md={sizemd} lg={sizelg}>
      <div className="addVideo_form_field_div">
        <div className="form_label">
          {label}
          {isRequired && <span className={"required"}>*</span>}
        </div>
        {isDropdown ? (
          <FormControl fullWidth size="small" error={!!errors[name]} style={{backgroundColor:"white"}}>
            {/* <InputLabel>{label}</InputLabel> */}
            <Select
              name={name}
              {...register(name, {
                required: `${label} is required`,
              })}
              onBlur={onInputChange}
              defaultValue={defaultValue}
            >
              {dropdownOptions.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {errors[name] && (
              <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '3px' }}>
                {errors[name]?.message}
              </div>
            )}
          </FormControl>
        ) : (
          <TextField
            size="small"
            fullWidth
            name={name}
            className={"textfield"}
            type="text"
            {...register(name, {
              required: `${label} is required`,
            })}
            error={!!errors[name]}
            helperText={errors[name]?.message}
            onBlur={onInputChange}
          />
        )}
      </div>
    </Grid>
  );
};

export {AddProfileTitle,AddInputField,PasswordInputField,UpdateButton,DropdownField} ;
